import clsx from "clsx";
import { useForm as useFormHook } from "hooks";
import { convertToDateTime } from "util/transformers";
import type { HighRiskMerchant } from 'features/ecommerce/types';
import {
    FormField,
    type OnboardingBusinessInformation,
    type OnboardingBusinessInformationForm
} from "./types";
import { BooleanSwitchValue } from "consts/general";
// import useValidationSchema from "./useValidationSchema";

export const getInitialValues = ({
    yearsUnderOwnership,
    incorporationDate,
    techContactName,
    techContactPhone,
    techContactEmail,
    finContactName,
    finContactPhone,
    finContactEmail,
    emergencyContactName,
    emergencyContactPhone,
    emergencyContactEmail,
    ...restInitialValues
}: Partial<HighRiskMerchant.OnboardingBusinessInformation>): OnboardingBusinessInformation => ({
    [FormField.MailingAddress]: '',
    [FormField.UseContactDeatilsForTech]: false,
    [FormField.UseContactDeatilsForFin]: false,
    [FormField.UseContactDeatilsForEmergency]: false,
    [FormField.UseSinceIncorporationDate]: false,
    [FormField.LegalNameOfBusiness]: '',
    [FormField.TradeName]: '',
    [FormField.EntityType]: null,
    [FormField.YearsUnderOwnership]: clsx(yearsUnderOwnership),
    [FormField.ProductsSold]: '',
    [FormField.IncorporationId]: '',
    [FormField.CountryOfIncorporation]: null,
    [FormField.IncorporationDate]: convertToDateTime(incorporationDate),
    [FormField.CompanyAddress]: '',
    [FormField.Country]: '',
    [FormField.City]: '',
    [FormField.PostalCode]: '',
    [FormField.ContactName]: '',
    [FormField.ContactEmail]: '',
    [FormField.ContactPhone]: '',
    [FormField.TechContactName]: clsx(techContactName),
    [FormField.TechContactEmail]: clsx(techContactEmail),
    [FormField.TechContactPhone]: clsx(techContactPhone),
    [FormField.FinContactName]: clsx(finContactName),
    [FormField.FinContactEmail]: clsx(finContactEmail),
    [FormField.FinContactPhone]: clsx(finContactPhone),
    [FormField.EmergencyContactName]: clsx(emergencyContactName),
    [FormField.EmergencyContactEmail]: clsx(emergencyContactEmail),
    [FormField.EmergencyContactPhone]: clsx(emergencyContactPhone),
    [FormField.WishDirectIntegration]: BooleanSwitchValue.On,
    [FormField.WishDirectIntegrationInput]: null,
    [FormField.IntegrationContactEmail]: '',
    ...restInitialValues
});

export const useForm = (onboardingBusinessInformation: OnboardingBusinessInformationForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingBusinessInformation,
        validateOnMount: true,
        // validationSchema: useValidationSchema()
    });
